module.exports = __webpack_public_path__ + "img/success2.7137ecd3.png";